import { MessageHeader } from "./MessageHeader";
import { MessageContent } from "./MessageContent";
import { SharePrompt } from "./SharePrompt";

export const SocialShareHeader = () => {
  return (
    <div className="w-full text-center">
      <MessageHeader />
      <MessageContent />
      <SharePrompt />
    </div>
  );
};